// ==========================
// Helper: Refresh cart items via Shopify section
// ==========================
function refreshCartItems() {
  // Returns the promise so callers can await the refresh before showing the drawer.
  return fetch('/cart?section_id=drawer')
    .then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const newItems = tempDiv.querySelector('.cart__drawer-center');
      const currentItems = document.querySelector('.cart__drawer-center');
      if (newItems && currentItems) currentItems.innerHTML = newItems.innerHTML;

      const newProgressbar = tempDiv.querySelector('.drawer_bottom');
      const currentProgressbar = document.querySelector('.drawer_bottom');
      if (newProgressbar && currentProgressbar) currentProgressbar.innerHTML = newProgressbar.innerHTML;
    })
    .catch(console.error);
}

// ==========================
// Open / Close Drawer
// ==========================
document.addEventListener('DOMContentLoaded', () => {
  const drawerWrapper = document.querySelector('#drawer');
  const drawer = document.querySelector('.cart__drawer');
  const overlay = document.querySelector('.cart__drawer-overlay');
  const closeBtn = document.querySelector('.cart__drawer-close');
  let scrollY = 0;

  if (!drawerWrapper || !drawer) return;

  async function openDrawer(options) {
    const awaitRefresh = !!(options && options.awaitRefresh);

    // After an add-to-cart, wait for the fresh markup so the drawer is never stale.
    if (awaitRefresh) {
      await refreshCartItems();
    }

    // position:fixed forces window.scrollY to 0, so only capture it while closed.
    if (!drawer.classList.contains('show')) {
      scrollY = window.scrollY;
      document.body.style.top = `-${scrollY}px`;
      document.body.classList.add('cv--show-cart__drawer');
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
    }

    drawer.classList.add('show');
    overlay.classList.add('show');

    if (!awaitRefresh) refreshCartItems();
  }

  function closeDrawer() {
    drawer.classList.remove("show");
    overlay.classList.remove("show");

    document.body.classList.remove("cv--show-cart__drawer");
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.width = "";

    window.scrollTo(0, scrollY);
  }

  // Open drawer
  document.body.addEventListener('click', function(e) {
    const btn = e.target.closest('.site-header__cart');

    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }
  });

  // Close drawer buttons
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  // Close on Escape key
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeDrawer();
  });

  function cartBubbleUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const bubble = document.querySelector('#CartCount');
        if (bubble) {
          bubble.innerText = cart.item_count;
        }
      })
      .catch(console.error);
  }

  // ==========================
  // Add to Cart
  // ==========================
  // Open the drawer once /cart/add.js completes; a lock blocks duplicate adds.
  (function () {
    if (!window.jQuery) {
      console.warn('[drawer] jQuery not found — drawer will not auto-open on add to cart.');
      return;
    }
    const $ = window.jQuery;

    let inFlight = 0;
    let safetyTimer = null;

    function addPath() {
      return (window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add';
    }

    function isCartAdd(url) {
      if (!url) return false;
      let path;
      try {
        path = new URL(url, window.location.origin).pathname;
      } catch (e) {
        path = String(url).split('?')[0];
      }
      return path === addPath() || path === addPath() + '.js' || /\/cart\/add(\.js)?$/.test(path);
    }

    $(document).ajaxSend(function (event, xhr, settings) {
      if (!isCartAdd(settings && settings.url)) return;
      inFlight++;
      // Failsafe: never leave the button locked if a request hangs.
      clearTimeout(safetyTimer);
      safetyTimer = setTimeout(function () { inFlight = 0; }, 10000);
    });

    $(document).ajaxComplete(function (event, xhr, settings) {
      if (!isCartAdd(settings && settings.url)) return;

      inFlight = Math.max(0, inFlight - 1);
      if (inFlight === 0) clearTimeout(safetyTimer);

      // Failed add (sold out, variant error) — leave the drawer closed.
      if (xhr.status < 200 || xhr.status >= 300) return;

      openDrawer({ awaitRefresh: true });
    });

    // Shared in-flight lock; capture phase runs before theme.js's submit handler.
    document.addEventListener('submit', function (e) {
      const form = e.target && e.target.closest
        ? e.target.closest('.product-purchase-form')
        : null;
      if (!form) return;
      if (inFlight > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
  })();

  // ==========================
  // Remove Item
  // ==========================
  drawerWrapper.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.cart-item__remove');
    if (removeBtn) {
      e.preventDefault();
      const itemUrl = removeBtn.getAttribute('href');

      fetch(itemUrl)
        .then(res => res.text())
        .then(() => {
          refreshCartItems();
          cartBubbleUpdate();
        })
        .catch(console.error);
    }
  });

  // ==========================
  // Quantity + / - Buttons
  // ==========================
  function debounce(fn, delay) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  const updateCartDebounced = debounce(function(form) {
    const formData = new FormData(form);

    fetch('/cart/update', { method: 'POST', body: formData })
      .then(res => res.text())
      .then(() => {
        refreshCartItems();
        cartBubbleUpdate();
      })
      .catch(console.error);
  }, 500);

  drawerWrapper.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('.quantity-up');
    const minusBtn = e.target.closest('.quantity-down');

    if (plusBtn || minusBtn) {
      e.preventDefault();
      const input = plusBtn ? plusBtn.previousElementSibling : minusBtn.nextElementSibling;
      const form = input.closest('form');
      let quantity = parseInt(input.value, 10);

      if (plusBtn) quantity += 1;
      else if (minusBtn && quantity > 0) quantity -= 1;

      input.value = quantity;
      updateCartDebounced(form);
    }
  });

  // ==========================
  // Recommendation add to cart
  // ==========================
  drawerWrapper.addEventListener('click', function(e) {
    const addTocart = e.target.closest('.cart__view-cart_recommendation');
    if (addTocart) {
      e.preventDefault();
      const itemUrl = addTocart.getAttribute('href');

      fetch(itemUrl)
        .then(res => res.text())
        .then(() => {
          refreshCartItems();
          cartBubbleUpdate();
        })
        .catch(console.error);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('.custom-option')) {
      const selectParent = e.target.closest('.recommendation-slide');
      selectVariant(selectParent);
    }
  });

  function selectVariant(selectParent) {
    if (!selectParent) return;

    const variantSelect = selectParent.querySelector('.custom-variant-selector');
    const atcButton = selectParent.querySelector('.cart__view-cart');
    const price = selectParent.querySelector('.price .theme-money:not(.was-price)');
    const compare_price = selectParent.querySelector('.price .was-price');

    if (!variantSelect || !atcButton) return;

    const selectedValues = [...selectParent.querySelectorAll('.custom-option')]
                          .map(select => select.value);

    const selectedTitle = selectedValues.join(" / ");

    const matchedVariant = [...variantSelect.options].find(
      opt => opt.value === selectedTitle
    );

    if (matchedVariant) {
      if (atcButton.hasAttribute('disabled')) atcButton.removeAttribute('disabled');
      // atcButton is an <a>, so the disabled attribute alone does not block clicks.
      atcButton.removeAttribute('aria-disabled');
      atcButton.style.pointerEvents = '';

      const variantId = matchedVariant.dataset.variantId;
      variantSelect.value = matchedVariant.value;
      atcButton.href = `/cart/add?id=${variantId}&quantity=1`;
      if (price) price.innerText = theme.Shopify.formatMoney(matchedVariant.dataset.variantPrice, theme.money_format_with_code_preference);
      if (compare_price) compare_price.innerText = theme.Shopify.formatMoney(matchedVariant.dataset.variantCompare, theme.money_format_with_code_preference);
    } else {
      if (price) price.innerText = "Unavailable";
      if (compare_price) compare_price.innerText = '';
      if (!atcButton.hasAttribute('disabled')) atcButton.setAttribute('disabled', 'disabled');
      atcButton.setAttribute('aria-disabled', 'true');
      atcButton.style.pointerEvents = 'none';
      console.warn("No matching variant found for:", selectedTitle);
    }
  }
});